import { gql } from '@apollo/client';
import type { DailyTaskMonitoringListData } from './getDailyTaskMonitoringList';

// DSP 用户专用：与 WHS 版字段一致，仅替换 operation 名为 ForDsp 版本
export const GET_DSP_DAILY_TASK_MONITORING_LIST = gql`
  query GetDailyTaskMonitoringListForDsp($filter: DailyTaskMonitoringFilterTypeInput!, $pageRequest: DailyTaskPageRequestTypeInput!) {
    getDailyTaskMonitoringListForDsp(filter: $filter, pageRequest: $pageRequest) {
      calculatedAt
      summaryData {
        deliveryProgress {
          scheduledParcels
          actualPickedUp
          deliveredParcels
          pickupRate
          deliveryRate
        }
        undeliveredDistribution {
          totalUndelivered
          unpicked
          inDelivery
          failedReturned
          failedNotReturned
          warehouseLost
        }
      }
      recordData {
        id
        taskDate
        warehouseId
        warehouseName
        dspId
        dspName
        areaId
        driverId
        allocatedParcels
        pickedUpFromWarehouse
        warehouseLost
        inDelivery
        deliveryRate
        onTimeDelivery
        overdueDelivery
        deliveredCount
        unclaimedCount
        noAscanDelivery
        transferredIn
        transferredOut
        returned
        damaged
        driverName
        lastDeliveryTime
        dwellTime
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export interface GetDspDailyTaskMonitoringListResponse {
  getDailyTaskMonitoringListForDsp: DailyTaskMonitoringListData;
}
